import React from 'react';
import { Link } from 'react-router-dom';
import { Article } from '../types';

interface ArticleCardProps {
  article: Article;
  featured?: boolean;
}

const formatDate = (value?: string) => {
  if (!value) return 'Без даты';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? 'Без даты' : date.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

const ArticleCard: React.FC<ArticleCardProps> = ({ article, featured = false }) => (
  <Link className={`atlas-record${featured ? ' atlas-record-featured' : ''}`} to={`/articles/${article.slug}`}>
    <span className="atlas-record-symbol" aria-hidden="true"><span className="atlas-file-icon">⌘</span></span>
    <span className="atlas-record-copy">
      <span className="atlas-meta">{article.visibility === 'private' ? 'ЗАКРЫТЫЙ МАТЕРИАЛ' : 'ЗАМЕТКА'} / {formatDate(article.date_created)}</span>
      <span className="atlas-record-title">{article.title}</span>
      <span className="atlas-record-summary">{article.excerpt || 'Материал из базы инженерного опыта.'}</span>
    </span>
    <span className="atlas-record-arrow" aria-hidden="true">↗</span>
  </Link>
);

export default ArticleCard;
